/* Stellora IL · אדוורטוריאל מקביל שמוביל ללנדר החדש

   האדוורטוריאל המקורי מפנה עשרה קישורים אל /products/bunion-fix.
   כאן מפנים אותם אל /pages/bunion-buy, הלנדר עם קופסת הבחירה והמגירה.

   למה ב-JS ולא בשכפול הטקסט: שני גופי האדוורטוריאל הם 89KB ו-88KB,
   177KB ביחד. שכפול רק כדי להחליף כתובת היה מכפיל את התחזוקה.

   ⚠️ הסדר חשוב. bn-funnel.js מוסיף את פרמטרי הפרסום (utm, fbclid)
   לתוך ה-href של a[data-bn-carry]. הקובץ הזה נטען אחריו, ומחליף רק
   את ה-pathname ושומר את ה-search.

   ⚠️ בלי ביטויים רגולריים כאן, בכוונה. הגרסה הקודמת השתמשה ב-regex
   והלוכסן ההפוך שרד את המעבר דרך ה-API, מה שהפיל את הקובץ כולו עם
   Invalid regular expression flags ואף קישור לא הופנה. השוואת
   מחרוזות פשוטה עושה את אותה עבודה ולא שבירה. */
(function () {
  'use strict';
  var TARGET = '/pages/bunion-buy';
  var SOURCE = '/products/bunion-fix';

  function repoint() {
    var n = 0;
    document.querySelectorAll('a[href]').forEach(function (a) {
      var raw = a.getAttribute('href') || '';
      var u;
      try { u = new URL(raw, location.origin); } catch (e) { return; }
      if (u.host !== location.host) return;
      var p = u.pathname;
      if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
      if (p !== SOURCE) return;
      a.setAttribute('href', TARGET + u.search + u.hash);
      n++;
    });
    return n;
  }

  repoint();
  window.addEventListener('load', repoint);
  setTimeout(repoint, 1500);
})();